import React from 'react';
import styled from 'styled-components';
import { XR } from '@orderx/lab/xr';

export const BoxAnimation = styled(XR.Card)`
    &:not(.invalid) {
        position: relative;
        z-index: 0;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            z-index: -2;
            width: 400%;
            height: 400%;
            background-color: var(--XR-color-success);
            opacity: 0.2;
            background-repeat: no-repeat;
            background-size: 50% 50%, 50% 50%;
            background-position: 0 0, 100% 0, 100% 100%, 0 100%;
            animation: AnimationBoxAnimation 32s linear infinite;
        }
    }
`;
